import { ABMGenerico } from "src/general_components/ABMGenerico";

export const TipoEstantes = () => {
    const modelo = "tipo_estante";

    return (
        <>
            <ABMGenerico modelo={modelo} titulo={"Tipo de Estantes"} />
        </>
    );
};
